export default __webpack_public_path__ + "static/media/logo-small.16d213b9.svg";